import { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import Header from '../components/Header'
import { SITE_URL, safeNext, rememberReset, describeResetError } from '../lib/passwordReset'

export default function ForgotPassword() {
const [searchParams] = useSearchParams()
const next = safeNext(searchParams.get('next'))
const [email, setEmail] = useState(searchParams.get('email') || '')
const [loading, setLoading] = useState(false)
const [error, setError] = useState('')
const [sent, setSent] = useState(false)

const handleSubmit = async () => {
setError('')
if (!email.trim()) { setError('Please enter your email address'); return }
setLoading(true)
const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
redirectTo: `${SITE_URL}/reset-password${next ? `?next=${encodeURIComponent(next)}` : ''}`,
})
setLoading(false)
if (error) { setError(describeResetError(error)); return }
rememberReset({ email: email.trim(), next })
setSent(true)
}

return (
<div>
<Header />
<div style={{ display: 'flex', justifyContent: 'center', padding: '3rem 1rem' }}>
<div style={{ width: '100%', maxWidth: 420 }}>
<div style={{ textAlign: 'center', marginBottom: '2rem' }}>
<div style={{ fontSize: 40, marginBottom: 8 }}>🔒</div>
<h1 style={{ fontSize: 24, fontWeight: 600, color: 'var(--navy)' }}>Forgot password?</h1>
<p style={{ color: 'var(--text-muted)', marginTop: 4 }}>
{sent ? "We've sent you a reset link" : "We'll email you a link to reset it"}
</p>
</div>

<div className="card card-body">
{sent ? (
<>
<div className="alert alert-success">Check your email for a reset link. It expires in 1 hour. Don't forget to look in your spam folder. If you ask more than once, only the newest email will work.</div>
<Link to={`/reset-password?code=1&email=${encodeURIComponent(email.trim())}`} className="btn btn-primary btn-lg btn-full" style={{ textDecoration: 'none', textAlign: 'center', marginBottom: 8 }}>I have a code from my email</Link>
<Link to="/auth" className="btn btn-ghost btn-lg btn-full" style={{ textDecoration: 'none', textAlign: 'center' }}>← Back to sign in</Link>
</>
) : (
<>
<div className="form-group">
<label className="form-label">Email address</label>
<input className="form-control" type="email" placeholder="you@email.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
</div>

{error && <div className="alert alert-error">{error}</div>}
<button className="btn btn-gradient btn-lg btn-full" onClick={handleSubmit} disabled={loading}>
{loading ? '...' : 'Send reset link'}
</button>
<p style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-muted)', marginTop: 16 }}>
Remembered it?{' '}
<Link to="/auth" style={{ color: 'var(--primary)', fontWeight: 500, textDecoration: 'none' }}>Sign in</Link>
</p>
</>
)}
</div>
</div>
</div>
</div>
)
}
